// removed by extract-text-webpack-plugin
module.exports = {"WorkItem":"WorkItem__WorkItem___2PE2y","JobHeading":"WorkItem__JobHeading___RsJYU","JobTitle":"WorkItem__JobTitle___173pU","CompanyTitle":"WorkItem__CompanyTitle___3iQSR","Timeline":"WorkItem__Timeline___3CP_n","Company":"WorkItem__Company___3ZMFt","Description":"WorkItem__Description___39qGM","clearfix":"WorkItem__clearfix___1FH4U"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/ResumeBox/Resume/WorkHistory/WorkItem/WorkItem.css
// module id = 38
// module chunks = 0